import { getCurrentLang, TLang } from '@umu/ukit-lang';
import { getCharacterLength } from './umuUtil';
import { InputCountType } from '@umu/umu-design';

const doubleChartLangs: TLang[] = ['cn', 'tw', 'jp', 'ko'];
/**
 * @description: 获取字符限制长度 非 doubleChartList 语言下限制长度为 count * 2
 * @param {number} count
 * @param {TLang} lang
 * @return {number}
 */
export const getChartLimitLenByLang = (count: number, lang: TLang = getCurrentLang()): number => {
    return doubleChartLangs.includes(lang) ? count : count * 2;
};
/**
 * @description: 获取字符串的字符长度 doubleChartList 为双字节字符的语言列表 在这些语言中英文字符占0.5个字符 其他语言下 doubleChartList 字符占2个字符
 * @param {string} str
 * @param {TLang} lang
 * @return {number}
 */
export const getChartCountByLang = (str: string, lang = getCurrentLang()) => {
    const charLength = getCharacterLength(str);
    return doubleChartLangs.includes(lang) ? parseInt(String(getCharacterLength(str) / 2), 10) : charLength;
};
/**
 * @desc 是否按照双字节进行限制
 */
export const isDoubleChartLimit = (lang = getCurrentLang()) => doubleChartLangs.includes(lang);
/**
 *
 */
export const getInputCountType = (lang = getCurrentLang()) => {
    return isDoubleChartLimit(lang) ? InputCountType.character : InputCountType.character2;
};
